import { DropOffOrderLineItemDTO, InternationalStringDTO, PickUpOrderLineItemDTO, SeatDTO, TripCustomizationDTO, TripDTO } from "../../apiclient/ApiDtos"
import { TripSelectedFsmContext } from "../trip-selected/TripSelectedFsmContext"


export class WayPointSelectionFsmContext {
    constructor(
        public readonly tripSelectedContext: TripSelectedFsmContext,
        public readonly tripDetails: TripDTO | null,
        public readonly selectedSeats: SeatDTO[],
        public readonly addedPickupLineItems: PickUpOrderLineItemDTO[] = [],
        public readonly addedDropOffLineItems: DropOffOrderLineItemDTO[] = [],
        public readonly tripCustomization: TripCustomizationDTO,
        public readonly errorMessage?: InternationalStringDTO | null
    ) { }

    withTripDetails(tripDetails: TripDTO): WayPointSelectionFsmContext {
        return new WayPointSelectionFsmContext(
            this.tripSelectedContext, tripDetails, this.selectedSeats, this.addedPickupLineItems, this.addedDropOffLineItems,
            this.tripCustomization, this.errorMessage
        )
    }

    withTripCustomization(tripCustomization: TripCustomizationDTO) {
        return new WayPointSelectionFsmContext(
            this.tripSelectedContext, this.tripDetails, this.selectedSeats, this.addedPickupLineItems, this.addedDropOffLineItems,
            tripCustomization, this.errorMessage
        )
    }

    withErrorMessage(errorMessage: InternationalStringDTO) {
        return new WayPointSelectionFsmContext(
            this.tripSelectedContext, this.tripDetails, this.selectedSeats, this.addedPickupLineItems, this.addedDropOffLineItems,
            this.tripCustomization, errorMessage
        )
    }

    withSelectedPickUpOptions(pickupOptions: PickUpOrderLineItemDTO[]) {
        return new WayPointSelectionFsmContext(
            this.tripSelectedContext, this.tripDetails, this.selectedSeats, mergePickUpOptions(pickupOptions), this.addedDropOffLineItems,
            this.tripCustomization, this.errorMessage
        )
    }

    withDropOffOptions(dropOffOptions: DropOffOrderLineItemDTO[]) {
        return new WayPointSelectionFsmContext(
            this.tripSelectedContext, this.tripDetails, this.selectedSeats, this.addedPickupLineItems, mergePickUpOptions(dropOffOptions),
            this.tripCustomization, this.errorMessage
        )
    }

    hasPickUpDropOffOrder(): boolean {
        if (this.tripCustomization == undefined || this.tripCustomization.pickUpOrder == undefined || this.tripCustomization.dropOffOrder == undefined) {
            return false;
        }

        if (
            this.tripDetails?.hasPickUpService ||
            this.tripDetails?.hasDropOffService ||
            this.tripCustomization.pickUpOrder.lineItems.length > 0
            || this.tripCustomization.dropOffOrder.lineItems.length > 0
        ) {
            return true;
        }

        return false;
    }
}


function mergePickUpOptions(
    pickupOptions: PickUpOrderLineItemDTO[]
): PickUpOrderLineItemDTO[] {
    const mergedMap = new Map<string, PickUpOrderLineItemDTO>();

    for (const item of pickupOptions) {
        const trimmedAddress = item.address.trim();
        const key = `${item.option.id}_${trimmedAddress.toLowerCase()}`;

        const existing = mergedMap.get(key);

        if (existing) {
            existing.numberOfSeats += item.numberOfSeats;
        } else {
            mergedMap.set(key, {
                ...item,
                address: trimmedAddress
            });
        }
    }

    return Array.from(mergedMap.values());
}